import { createContext } from 'react';

export const ValidationContext = createContext({});
